// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"120":"b860704cfd8fdf44","318":"0a432a9be2969d05"}[chunkId] + ".js";
};